<div class="acc-topics-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="topicSpecialists()"></grid-content>
</div>